export const roles = {
    admin: "admin",
    waiter: "waiter",
    chef: "chef",
};

export const routes = {
    home: "/",
    admin: "/admin",
    adminProducts: "/admin-products",
    order: "/order",
    readyOrder: "/readyOrder",
    kitchen: "/kitchen",
};